/* ========================================================================
   General
 ========================================================================== */

app.general = (function () {
  'use strict';

  const updateAppHeight = util.debounce(() => {
    document.documentElement.style.setProperty(
      '--app-height',
      window.innerHeight + 'px'
    );

    // Save screen width to cookie
    util.setCookie(
      'dashboardVersion',
      window.innerWidth >= 1024 ? 'desktop' : 'mobile'
    );

    // Check dashboard version
    checkDashboardVersion();
  }, 250);

  function initAppHeight() {
    // Init app height
    updateAppHeight();

    // Handle app height on resize
    window.addEventListener(
      'resize',
      () => {
        updateAppHeight();
      },
      { passive: true }
    );
  }

  function checkDashboardVersion() {
    const dashboard = document.querySelector('[data-dashboard]');
    if (!dashboard) return;

    if (dashboard.dataset.version !== util.getCookie('dashboardVersion')) {
      window.location.reload();
    }
  }

  // Expose public functions and variables
  return {
    initAppHeight: initAppHeight,
    updateAppHeight: updateAppHeight,
  };
})();
